import React, { useContext, useState } from 'react';
import './styles.scss';
import Page from '../Page';
import { ASSubpageEnum, PageChildrenEnum } from '../../enums';
import { EditorialContentProps } from '../Page/interfaces';
import Textbox from '../../components/AutostadtTabComponents/Tiles/Textbox';
import Teaserbox from '../../components/AutostadtTabComponents/Tiles/Teaserbox';
import Countdown from '../../components/AutostadtTabComponents/Countdown';
import i18next from 'i18next';
import { Textlink, TileButton } from '../../components/AutostadtTabComponents/Button';
import { setASSubpage } from '../../utils/SspProvider/dispatchFunctions';
import SspProviderContext from '../../utils/SspProvider/context';
import SliderTile from '../../components/AutostadtTabComponents/Tiles/SliderTile';
import { useConfig } from '../../utils/AutostadtContextProvider';
import { dataNodesFromArray } from '../../utils/AutostadtContextHelpers';
import { Trans } from 'react-i18next';
import { daysBetweenNowAnd } from '../../utils/daysBetweenNowAnd';

export default function PickUp(props: EditorialContentProps): JSX.Element {
    const config = useConfig();
    const [iframe, setIframe] = useState<string>('');
    const store = useContext(SspProviderContext);
    const days = daysBetweenNowAnd(
        store.state.content?.asModel.arr('market_specific_list').find(obj => obj.Key === 'APPOINTMENT_DATE')?.Value
    );

    const carouselTiles = [
        {
            image: '/AutostadtTab/anreise.webp',
            title: i18next.t('Arrival'),
            subline: i18next.t('CarouselArrivalSubline'),
            onClick: ASSubpageEnum.Arrival,
        },
        /*{
            image: '/AS-header.webp',
            title:  i18next.t('ProcedureOnSite'),
            subline: i18next.t('CarouselProcedureOnSiteSubline'),
            onClick: ASSubpageEnum.ProcedureOnSite,
        },*/
        {
            image: '/dummy_image%204_3.webp',
            title: i18next.t('OpeningHours'),
            subline: i18next.t('CarouselOpeningHoursSubline'),
            onClick: ASSubpageEnum.OpeningHours,
        },
        {
            image: '/AutostadtTab/Teaser_Lageplan.webp',
            title: i18next.t('Map'),
            subline: i18next.t('CarouselMapSubline'),
            onClick: ASSubpageEnum.Map,
        },
    ];

    return (
        <Page
            child={PageChildrenEnum.PickUp}
            iframeSrc={iframe}
            closeIframe={() => setIframe('')}
            editorialContent={props.editorialContent}
        >
            <section className='pick-up' id='intro'>
                <img src='/autostadt_towers.webp' alt='Ein Bild von den Autostadt Türmen' />
                {days || days === 0 ? <Countdown days={days} /> : <></>}
                <h2>{days <= 0 ? i18next.t('MainTitleRetrieval') : i18next.t('MainTitleCountdown')}</h2>
                <p className='body large'>
                    {days <= 0 ? (
                        <Trans
                            i18nKey={'MainSubtitleRetrieval'}
                            components={{
                                strong: <strong />,
                                br: <br />,
                            }}
                        />
                    ) : (
                        <Trans
                            i18nKey={'MainSubtitleCountdown'}
                            components={{
                                br: <br />,
                            }}
                        />
                    )}
                </p>
                {days <= 0 && (
                    <Textlink
                        color='dark-blue'
                        text={i18next.t('GoodToKnowRetrieval')}
                        onClick={() => {
                            document.getElementById('pick-up-day')?.scrollIntoView({
                                behavior: 'smooth',
                                block: 'start',
                            });
                        }}
                    />
                )}
                <div id='organizational'>
                    {days <= 0 ? (
                        <TileButton
                            svg='as-delay'
                            label={i18next.t('DelayBtn')}
                            onClick={() => {
                                setASSubpage(store, {
                                    asEnum: ASSubpageEnum.Delay,
                                });
                            }}
                        />
                    ) : (
                        <div className='tile-button-container'>
                            <TileButton
                                svg='smiley'
                                label={i18next.t('HappinessPlanner')}
                                onClick={() => {
                                    setASSubpage(store, {
                                        asEnum: ASSubpageEnum.HappinessPlanner,
                                    });
                                }}
                            />
                            <TileButton
                                svg='check-in'
                                label={i18next.t('OnlineCheckInBtn')}
                                onClick={() => {
                                    setASSubpage(store, {
                                        asEnum: ASSubpageEnum.OnlineCheckIn,
                                    });
                                }}
                            />
                        </div>
                    )}
                </div>
                <Textbox
                    headline={i18next.t('ChecklistTileTitle')}
                    text={days <= 0 ? i18next.t('ChecklistTextDayOf') : i18next.t('ChecklistTextCountdown')}
                    buttonText={i18next.t('ChecklistBtn')}
                    color='blue'
                    svg='checklist'
                    centered={true}
                    onClick={() => {
                        setASSubpage(store, {
                            asEnum: ASSubpageEnum.Checklist,
                        });
                    }}
                />

                <h2 id='day-planning'>{i18next.t('DiscoveriesTitle')}</h2>
                <div className='discoveries-container'>
                    <Teaserbox
                        size='small'
                        headline={i18next.t('ExperienceTitle')}
                        text={i18next.t('ExperienceText')}
                        asset='/AutostadtTab/entdecken.webp'
                        onClick={() => {
                            setASSubpage(store, {
                                asEnum: ASSubpageEnum.Experience,
                            });
                        }}
                    />
                    <Teaserbox
                        size='small'
                        headline={i18next.t('UpgradesTitle')}
                        text={i18next.t('UpgradesText')}
                        asset='/AutostadtTab/upgrades2.webp'
                        onClick={() => {
                            setASSubpage(store, {
                                asEnum: ASSubpageEnum.Upgrades,
                            });
                        }}
                    />
                    <Teaserbox
                        size='small'
                        headline={i18next.t('GastronomyTitle')}
                        text={i18next.t('GastronomyText')}
                        asset='/AutostadtTab/gastronomie.webp'
                        onClick={() => {
                            setASSubpage(store, {
                                asEnum: ASSubpageEnum.Gastronomy,
                            });
                        }}
                    />
                    <Teaserbox
                        size='small'
                        headline={i18next.t('ShopsTitle')}
                        text={i18next.t('ShopsText')}
                        asset='/AutostadtTab/shops.webp'
                        onClick={() => {
                            setASSubpage(store, {
                                asEnum: ASSubpageEnum.Shops,
                            });
                        }}
                    />
                </div>
                <h2>{i18next.t('ExperienceExtraordinaryTitle')}</h2>
                <Teaserbox
                    size='large'
                    headline={dataNodesFromArray(config, ['The Ritz-Carlton, Wolfsburg'])[0].titel}
                    text={dataNodesFromArray(config, ['The Ritz-Carlton, Wolfsburg'])[0].teaser}
                    asset={dataNodesFromArray(config, ['The Ritz-Carlton, Wolfsburg'])[0].bild_url}
                    onClick={() => {
                        setASSubpage(store, {
                            asEnum: ASSubpageEnum.RitzCarlton,
                        });
                    }}
                    id='ritz-carlton'
                />
                <Teaserbox
                    id='additional-services'
                    size='large'
                    headline={i18next.t('AdditionalServicesTitle')}
                    text={i18next.t('AdditionalServicesText')}
                    asset='./additional_services.webp'
                    onClick={() => {
                        setASSubpage(store, {
                            asEnum: ASSubpageEnum.AdditionalServices,
                        });
                    }}
                />
                <SliderTile id='pick-up-day' headline={i18next.t('GoodToKnowCarouselTitle')} tiles={carouselTiles} />
            </section>
        </Page>
    );
}
